import axios from "axios";
import store from "@/store";

const request = axios.create({
    baseURL: '/api',
    timeout: 5000
})
request.interceptors.request.use(config => {
    //header添加token
    let token = store.getters.token
    if (token) {
        config.headers.Authorization = "Bearer " + token
    }
    return config
})
request.interceptors.response.use(response => {

    if (response.status == 200) {
        return response.data
    } else {
        return Promise.reject(new Error('faile'))
    }

}, error => {
    return Promise.reject(new Error('faile'))
})

export default request